import { useIntl } from 'react-intl'
import { useAppSelector } from 'store/hooks'
import Info from 'components/shared/Info'
import { useContext } from 'react'
import { UpsellsContext } from './utils/upsellsContext'

const NotFinishedUpsellInfo = () => {
    const { formatMessage } = useIntl()

    const { isEditingSpaInProgress } = useContext(UpsellsContext)

    const { routes } = useAppSelector((state) => state.transport)
    const { cabanas } = useAppSelector((state) => state.cabana)
    // const {
    //     memoryCapture: memoryCaptureOrder,
    //     isAddingMemoryCaptureInProgress,
    // } = useAppSelector((state) => state.upsell)

    const isTransportUnfinished = routes.some((route) => !route.isSubmitted)
    const isCabanaUnfinished = cabanas.some((cabana) => !cabana.isSubmitted)
    // const isMemoryCaptureUnfinished =
    //     memoryCaptureOrder?.cartItemId &&
    //     memoryCaptureOrder.quantity === 0 &&
    //     isAddingMemoryCaptureInProgress

    return (
        <>
            {isEditingSpaInProgress && (
                <Info color="info">
                    {formatMessage({
                        id: 'upsells.msg.spa_order_not_completed',
                        defaultMessage:
                            'Dodawanie Wellness & SPA nie zostało zakończone.',
                    })}
                </Info>
            )}

            {isTransportUnfinished && (
                <Info color="info">
                    {formatMessage({
                        id: 'upsells.msg.transport_order_not_completed',
                        defaultMessage:
                            'Dodawanie Suntago Bus nie zostało zakończone.',
                    })}
                </Info>
            )}

            {isCabanaUnfinished && (
                <Info color="info">
                    {formatMessage({
                        id: 'upsells.msg.caban_order_not_completed',
                        defaultMessage:
                            'Dodawanie Caban nie zostało zakończone.',
                    })}
                </Info>
            )}

            {/* TODO: memory capture */}
            {/* {!!isMemoryCaptureUnfinished && (
                <Info color="info">
                    {formatMessage({
                        id: 'upsells.msg.memory_order_not_completed',
                        defaultMessage:
                            'Dodawanie Memory Capture nie zostało zakończone.',
                    })}
                </Info>
            )} */}
        </>
    )
}

export default NotFinishedUpsellInfo
